import ConditionStatus from "./ConditionStatus";
import instanceFrag from "./Instance";

const Condition = (props = {}) => {
  // Handle case where props is true (include defaults) vs object (use configured fields)
  const includeDefaults = props === true || Object.keys(props).length === 0;
  const propsObj = typeof props === "object" && props !== null ? props : {};

  const {
    // Associations
    instance = false,
    mountStatus = false,
    status = false,
    // Scalar fields
    actionRequired = includeDefaults,
    actionTaken = includeDefaults,
    annotationUrl = includeDefaults,
    articheckId = includeDefaults,
    articheckRevision = includeDefaults,
    artistIntent = includeDefaults,
    artistIntentInclude = includeDefaults,
    date = includeDefaults,
    description = includeDefaults,
    details = includeDefaults,
    detailsExternal = includeDefaults,
    detailsExternalInclude = includeDefaults,
    detailsInternal = includeDefaults,
    detailsInternalInclude = includeDefaults,
    dimsArtwork = includeDefaults,
    dimsFramed = includeDefaults,
    exhibition = includeDefaults,
    exhibitionInclude = includeDefaults,
    fixings = includeDefaults,
    frame = includeDefaults,
    image = includeDefaults,
    instanceId = includeDefaults,
    jobId = includeDefaults,
    link = includeDefaults,
    location = includeDefaults,
    mount = includeDefaults,
    mountStatusId = includeDefaults,
    neon = includeDefaults,
    packing = includeDefaults,
    packSpec = includeDefaults,
    staff = includeDefaults,
    statusId = includeDefaults,
    technician = includeDefaults,
    time = includeDefaults,
    user = includeDefaults,
    userCreate = includeDefaults,
    work = includeDefaults,
  } = propsObj;

  return `
  id
  ${actionRequired ? "actionRequired" : ""}
  ${actionTaken ? "actionTaken" : ""}
  ${annotationUrl ? "annotationUrl" : ""}
  ${articheckId ? "articheckId" : ""}
  ${articheckRevision ? "articheckRevision" : ""}
  ${artistIntent ? "artistIntent" : ""}
  ${artistIntentInclude ? "artistIntentInclude" : ""}
  ${date ? "date" : ""}
  ${description ? "description" : ""}
  ${details ? "details" : ""}
  ${detailsExternal ? "detailsExternal" : ""}
  ${detailsExternalInclude ? "detailsExternalInclude" : ""}
  ${detailsInternal ? "detailsInternal" : ""}
  ${detailsInternalInclude ? "detailsInternalInclude" : ""}
  ${dimsArtwork ? "dimsArtwork" : ""}
  ${dimsFramed ? "dimsFramed" : ""}
  ${exhibition ? "exhibition" : ""}
  ${exhibitionInclude ? "exhibitionInclude" : ""}
  ${fixings ? "fixings" : ""}
  ${frame ? "frame" : ""}
  ${image ? "image" : ""}
  ${
    instance
      ? `instance {
      ${instanceFrag(instance)}
    }`
      : ""
  }
  ${instanceId ? "instanceId" : ""}
  ${jobId ? "jobId" : ""}
  ${link ? "link" : ""}
  ${location ? "location" : ""}
  ${mount ? "mount" : ""}
  ${
    mountStatus
      ? `mountStatus {
      ${ConditionStatus}
    }`
      : ""
  }
  ${mountStatusId ? "mountStatusId" : ""}
  ${neon ? "neon" : ""}
  ${packing ? "packing" : ""}
  ${packSpec ? "packSpec" : ""}
  ${staff ? "staff" : ""}
  ${
    status
      ? `status {
      ${ConditionStatus}
    }`
      : ""
  }
  ${statusId ? "statusId" : ""}
  ${technician ? "technician" : ""}
  ${time ? "time" : ""}
  ${user ? "user" : ""}
  ${userCreate ? "userCreate" : ""}
  ${work ? "work" : ""}
`;
};

export default Condition;
